import { BoldOutlined, BulbOutlined, EyeOutlined, GlobalOutlined, LeftOutlined, RocketOutlined, SendOutlined, ShareAltOutlined, TeamOutlined, UserOutlined, UserSwitchOutlined } from '@ant-design/icons'
import { Alert, Badge, Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Modal, Radio, Row, Segmented, Select, Space, Spin, Tag } from 'antd'
import { useForm } from 'antd/lib/form/Form';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { labelComponent } from '../../util/UtilComponents';
import TextArea from 'antd/lib/input/TextArea';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetBreakpoints } from '../../hooks/useGetBreakpoints';
import { axiosInstance, BASE_API_CONFIG } from '../../util/Api';
import {
  isManufacturer,
  showAlert,
} from "../../util/helper";
import { isArrayNonEmpty } from '../../util/ApiHelper';
import moment from 'moment';

const Updatesfreightrates = () => {
  const [form] = useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingRecordId, setEditingRecordId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [upgradeModalVisible, setUpgradeModalVisible] = useState(false);
  const [loadingExporters, setLoadingExporters] = useState(false);
  const [exporterModalVisible, setExporterModalVisible] = useState(false);
  const [matchedExporters, setMatchedExporters] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState(null);
  
  // Get ports from Redux EXACTLY LIKE SIGNUP FORM
  const ports = useSelector(({ common }) => common.ports);
  const countries = useSelector(({ common }) => common.countries);
  const userData = useSelector(({ auth }) => auth?.userData);
  const authUser = useSelector(({ auth }) => auth.userData);
  
  // Filtered ports states EXACTLY LIKE SIGNUP FORM
  const [indianPorts, setIndianPorts] = useState([]);
  const [portsList, setPortsList] = useState([]);



   const [myExporters, setMyExporters] = useState([]);
  const [loadingMyExporters, setLoadingMyExporters] = useState(false);
  const [selectedExporter, setSelectedExporter] = useState(null);
  const [exporterPortPairs, setExporterPortPairs] = useState([]);
  const [loadingExporterPorts, setLoadingExporterPorts] = useState(false);
  const [sendToType, setSendToType] = useState('all'); // 'all' or 'specific'
  const [showExporterSelector, setShowExporterSelector] = useState(false);
  const [filteredIndianPorts, setFilteredIndianPorts] = useState([]);
  const [filteredDestinationPorts, setFilteredDestinationPorts] = useState([]);
  const [availableDestinationPorts, setAvailableDestinationPorts] = useState([]);

  // For port pairs (if you want to use multiple like signup)
  const [portPairs, setPortPairs] = useState([]);
  const [selectedLoadingPort, setSelectedLoadingPort] = useState(null);
  const [selectedDestinationPort, setSelectedDestinationPort] = useState(null);
  
  const location = useLocation();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const { Option } = Select;

  const userId = userData?.id;
  const username = userData?.name;
  const userid = userData?.id;
  const companyName = userData?.companyName;

  // FILTER PORTS EXACTLY LIKE SIGNUP FORM
  useEffect(() => {
    if (isArrayNonEmpty(ports)) {
      // Indian ports (countryId === 105) - EXACT SAME FILTER LOGIC
      const filteredIndianPorts = Array.from(
        new Map(
          ports
            .filter((item) => item?.countryId === 105)
            .map((item) => [item.port, item])
        ).values()
      );
      setIndianPorts(filteredIndianPorts);
      
      // International ports (countryId !== 105) - EXACT SAME FILTER LOGIC
      const filteredPorts = Array.from(
        new Map(
          ports
            .filter((item) => item?.countryId !== 105)
            .map((item) => [item.port, item])
        ).values()
      );
      setPortsList(filteredPorts);
      
      console.log("Indian Ports count:", filteredIndianPorts.length);
      console.log("International Ports count:", filteredPorts.length);
    }
  }, [ports]);

  // For port pairs like signup (if you want to allow multiple)
  const addPortPair = () => {
    if (!selectedLoadingPort || !selectedDestinationPort) {
      showAlert("Please select both loading and destination ports!", "warning");
      return;
    }

    const existingPair = portPairs.find(
      pair => pair.loadingPortId === selectedLoadingPort && pair.destinationPortId === selectedDestinationPort
    );

    if (existingPair) {
      showAlert("This port pair already exists!", "warning");
      return;
    }

    if (portPairs.length >= 5) {
      showAlert("You can add maximum 5 port pairs!", "warning");
      return;
    }

    const newPair = {
      id: Date.now(),
      loadingPortId: selectedLoadingPort,
      destinationPortId: selectedDestinationPort
    };
    const updatedPairs = [...portPairs, newPair];
    setPortPairs(updatedPairs);
    form.setFieldsValue({ portPairs: updatedPairs });
    
    setSelectedLoadingPort(null);
    setSelectedDestinationPort(null);
    
    showAlert("Port pair added successfully!", "success");
  };

  const removePortPair = (pairId) => {
    setPortPairs(portPairs.filter(pair => pair.id !== pairId));
    showAlert("Port pair removed!", "success");
  };



 const fetchMyExporters = async () => {
    if (!userId) return;
    
    // Even if our check fails, we can still try to fetch
    // The API will return empty array if no exporters found
    try {
      setLoadingMyExporters(true);
      console.log('Fetching exporters for userId:', userId);
      
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/updates-freight-rates/exporters/${userId}`
      );
      
      console.log('Response data:', response.data);
      
      // Handle different response formats
      let exporters = [];
      if (response.data?.success && Array.isArray(response.data.data)) {
        exporters = response.data.data;
      } else if (Array.isArray(response.data?.rows)) {
        exporters = response.data.rows;
      } else if (Array.isArray(response.data)) {
        exporters = response.data;
      }
      
      console.log('Exporters found:', exporters.length);
      setMyExporters(exporters);
      
      if (exporters.length > 0) {
        setShowExporterSelector(true);
      }
      
    } catch (error) {
      console.error("Error fetching my exporters:", error);
      message.error("Failed to load exporters who added you");
    } finally {
      setLoadingMyExporters(false);
    }
  };



  // FETCH EXPORTER'S PORT PAIRS
  const fetchExporterPortPairs = async (exporterId) => {
    if (!exporterId) return;
    
    try {
      setLoadingExporterPorts(true);
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/updates-freight-rates/exporters/${exporterId}/port-pairs`
      );
      
      if (response.data.success) {
        const portPairs = response.data.data.portPairs || [];
        setExporterPortPairs(portPairs);
        
        // Filter ports based on exporter's port pairs
        filterPortsByExporter(portPairs);
      }
    } catch (error) {
      console.error("Error fetching exporter port pairs:", error);
      message.error("Failed to load exporter's port pairs");
    } finally {
      setLoadingExporterPorts(false);
    }
  };

  // Filter ports based on exporter's port pairs
// Filter ports based on exporter's port pairs and create mappings
// Filter ports based on exporter's port pairs and create mappings
// Filter ports based on exporter's port pairs and create mappings
const filterPortsByExporter = (portPairs) => {
  if (!portPairs || portPairs.length === 0) {
    setFilteredIndianPorts(indianPorts);
    setFilteredDestinationPorts(portsList);
    return;
  }

  console.log('Filtering ports based on exporter port pairs:', portPairs);

  // Create a map of loading port -> array of destination ports
  const newPortPairMap = new Map();
  const uniqueLoadingPorts = new Set();
  
  portPairs.forEach(pair => {
    // Clean up the string - remove extra spaces
    const cleanPair = pair.replace(/\s+/g, ' ').trim();
    console.log('Processing pair:', cleanPair);
    
    // Try multiple regex patterns
    const patterns = [
      /^(.+?)\s*\(([^)]+)\)\s*[→]\s*(.+?)\s*\(([^)]+)\)$/, // Standard with arrow
      /^(.+?)\s*\(([^)]+)\)\s*->\s*(.+?)\s*\(([^)]+)\)$/,   // With hyphen arrow
      /^(.+?)\(([^)]+)\)\s*[→]\s*(.+?)\(([^)]+)\)$/,        // No spaces
      /^(.+?)\(([^)]+)\)\s*->\s*(.+?)\(([^)]+)\)$/          // No spaces with hyphen
    ];
    
    let match = null;
    for (const pattern of patterns) {
      match = cleanPair.match(pattern);
      if (match) break;
    }
    
    if (match) {
      const loadingPortName = match[1].trim();
      const loadingPortCode = match[2].trim();
      const destinationPortName = match[3].trim();
      const destinationPortCode = match[4].trim();
      
      // Create a normalized key
      const loadingKey = `${loadingPortName} (${loadingPortCode})`;
      
      // Add to unique loading ports set
      uniqueLoadingPorts.add(loadingKey);
      
      if (!newPortPairMap.has(loadingKey)) {
        newPortPairMap.set(loadingKey, []);
      }
      
      // Add destination to the array (allow multiple destinations per loading port)
      newPortPairMap.get(loadingKey).push({
        name: destinationPortName,
        code: destinationPortCode,
        fullString: `${destinationPortName} (${destinationPortCode})`
      });
      
      console.log(`Added mapping: ${loadingKey} → ${destinationPortName} (${destinationPortCode})`);
    } else {
      console.log('Could not parse pair with any pattern:', pair);
    }
  });

  console.log('Port pair map created:');
  newPortPairMap.forEach((dests, key) => {
    console.log(`${key} → ${dests.map(d => d.fullString).join(', ')}`);
  });
  
  setPortPairMap(newPortPairMap);

  // Get unique loading ports from the set
  const loadingPorts = Array.from(uniqueLoadingPorts).map(loadingKey => {
    const match = loadingKey.match(/^(.+?)\s*\(([^)]+)\)$/);
    if (match) {
      return {
        name: match[1].trim(),
        code: match[2].trim(),
        fullString: loadingKey
      };
    }
    return null;
  }).filter(Boolean);

  console.log('Loading ports:', loadingPorts.map(lp => lp.fullString));

  // Filter Indian ports that match loading ports
  const filteredIndian = indianPorts.filter(port => 
    loadingPorts.some(lp => 
      port.port.toLowerCase() === lp.name.toLowerCase() ||
      port.port.toLowerCase().includes(lp.name.toLowerCase()) ||
      lp.name.toLowerCase().includes(port.port.toLowerCase()) ||
      port.code?.toLowerCase() === lp.code?.toLowerCase()
    )
  );

  console.log('Filtered Indian ports:', filteredIndian.map(p => `${p.port} (${p.code})`));
  setFilteredIndianPorts(filteredIndian.length > 0 ? filteredIndian : indianPorts);
  
  // Get all destination ports from the map (for the filtered list when no loading port selected)
  const allDestinations = Array.from(newPortPairMap.values()).flat();
  const filteredDest = portsList.filter(port => 
    allDestinations.some(dest => 
      port.port.toLowerCase() === dest.name.toLowerCase() ||
      port.port.toLowerCase().includes(dest.name.toLowerCase()) ||
      dest.name.toLowerCase().includes(port.port.toLowerCase()) ||
      port.code?.toLowerCase() === dest.code?.toLowerCase()
    )
  );
  
  console.log('Filtered destination ports (all):', filteredDest.map(p => `${p.port} (${p.code})`));
  setFilteredDestinationPorts(filteredDest.length > 0 ? filteredDest : portsList);
};
// Add state for port pair map
const [portPairMap, setPortPairMap] = useState(new Map());


// Handle loading port change
// Handle loading port change
// Handle loading port change
// Handle loading port change
const handleLoadingPortChange = (value) => {
  setSelectedLoadingPort(value);
  form.setFieldsValue({ destinationPort: undefined });
  
  console.log('========== HANDLE LOADING PORT CHANGE ==========');
  console.log('Loading port changed to value:', value);
  
  // Find the selected loading port details
  const selectedPort = indianPorts.find(p => p.id === value);
  console.log('Selected port details:', selectedPort);
  
  if (selectedPort && portPairMap.size > 0) {
    // Log all map keys for debugging
    console.log('All map keys:', Array.from(portPairMap.keys()));
    
    // Find the matching key in the map (case insensitive, space insensitive)
    const selectedPortKey = `${selectedPort.port} (${selectedPort.code})`;
    console.log('Looking for key:', selectedPortKey);
    
    // Try to find a matching key
    let matchedKey = null;
    let destinations = [];
    
    // First try exact match
    if (portPairMap.has(selectedPortKey)) {
      matchedKey = selectedPortKey;
      destinations = portPairMap.get(selectedPortKey);
      console.log('Found exact match with key:', matchedKey);
    } else {
      // Try fuzzy matching (ignore case, extra spaces)
      const normalizedSelected = selectedPortKey.replace(/\s+/g, '').toLowerCase();
      
      for (const key of portPairMap.keys()) {
        const normalizedKey = key.replace(/\s+/g, '').toLowerCase();
        if (normalizedKey === normalizedSelected) {
          matchedKey = key;
          destinations = portPairMap.get(key);
          console.log('Found fuzzy match with key:', key);
          break;
        }
      }
    }
    
    console.log('Found destinations:', destinations);
    
    if (destinations.length > 0) {
      // Filter destination ports based on the map
      const availableDestinations = portsList.filter(port => {
        return destinations.some(dest => {
          // Check if port matches any of the destination criteria
          const portMatches = 
            port.port.toLowerCase() === dest.name.toLowerCase() ||
            port.port.toLowerCase().includes(dest.name.toLowerCase()) ||
            dest.name.toLowerCase().includes(port.port.toLowerCase()) ||
            port.code?.toLowerCase() === dest.code?.toLowerCase();
          
          if (portMatches) {
            console.log(`Matched port: ${port.port} (${port.code}) with destination: ${dest.name} (${dest.code})`);
          }
          return portMatches;
        });
      });
      
      console.log('Available destinations found:', availableDestinations.length);
      console.log('Destination ports:', availableDestinations.map(p => `${p.port} (${p.code})`));
      
      setAvailableDestinationPorts(availableDestinations);
    } else {
      console.log('No destinations found for this loading port');
      setAvailableDestinationPorts([]);
    }
  } else {
    console.log('No port pair map or no selected port');
    setAvailableDestinationPorts([]);
  }
  console.log('==============================================');
};

  // Handle exporter selection
  // Handle exporter selection
const handleExporterChange = (exporterId) => {
  const exporter = myExporters.find(e => e.exporterId === exporterId);
  setSelectedExporter(exporter);
  setSelectedLoadingPort(null); // Reset loading port
  setSelectedDestinationPort(null); // Reset destination port
  setAvailableDestinationPorts([]); // Reset available destinations
  form.setFieldsValue({ 
    loadingPort: undefined,
    destinationPort: undefined 
  });
  
  if (exporter) {
    fetchExporterPortPairs(exporterId);
  } else {
    // Reset filters
    setFilteredIndianPorts(indianPorts);
    setFilteredDestinationPorts(portsList);
    setPortPairMap(new Map());
    setExporterPortPairs([]);
  }
};

  // Fetch subscription data
  const fetchSubscription = async () => {
    try {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
      );
      setSubscriptionData(response.data);
    } catch (err) {
      console.error('Subscription fetch error:', err);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchSubscription();
      fetchMyExporters();
    }
  }, [userId]);

  const isSubscribed = [1, 2, 3].includes(subscriptionData?.subscription?.planId);

  // Load existing data if editing
  useEffect(() => {
    if (location.state?.isEdit && location.state?.editData) {
      setIsEditMode(true);
      setEditingRecordId(location.state.editData.id);
      const editData = location.state.editData;
      
      // Find port IDs from the stored port names (similar to signup form parsing)
      let loadingPortId = null;
      let destinationPortId = null;
      
      // Try to match loading port from format: "Port Name (Code)"
      if (editData.loadingPort) {
        const match = editData.loadingPort.match(/(.+)\s\((.+)\)/);
        if (match) {
          const portName = match[1].trim();
          const portCode = match[2];
          const foundPort = indianPorts.find(p => 
            p.port === portName && p.code === portCode
          );
          loadingPortId = foundPort?.id || null;
        }
      }
      
      // Try to match destination port from format: "Port Name (Code)"
      if (editData.destinationPort) {
        const match = editData.destinationPort.match(/(.+)\s\((.+)\)/);
        if (match) {
          const portName = match[1].trim();
          const portCode = match[2];
          const foundPort = portsList.find(p => 
            p.port === portName && p.code === portCode
          );
          destinationPortId = foundPort?.id || null;
        }
      }
      
      form.setFieldsValue({
        loadingPort: loadingPortId,
        destinationPort: destinationPortId,
        oceanfreight: editData.oceanfreight,
        comments: editData.comments,
        currency: editData.currency || "USD",
        pricevalidity: editData.pricevalidity ? moment(editData.pricevalidity) : null,
        containerType: editData.containerType,
        vesselName: editData.vesselName,
        expectedDepartureDate: editData.expectedDepartureDate ? moment(editData.expectedDepartureDate) : null,
        transitDays: editData.transitDays,
      });
    }
  }, [location, form, indianPorts, portsList]);

  // Port selection validator
  const validatePortSelection = (_, value) => {
    const loadingPort = form.getFieldValue("loadingPort");
    if (value && loadingPort && value === loadingPort) {
      return Promise.reject(new Error("Loading and Destination ports cannot be the same"));
    }
    return Promise.resolve();
  };

  // Text area validation
  const validateTextArea = (_, value) => {
    if (value && value.length > 250) {
      return Promise.reject(
        new Error("Comments cannot exceed 250 characters")
      );
    }
    return Promise.resolve();
  };

  // Show matched exporters
  const showMatchedExporters = async () => {
    try {
      setLoadingExporters(true);
      const loadingPortId = form.getFieldValue("loadingPort");
      const destinationPortId = form.getFieldValue("destinationPort");
      
      if (!loadingPortId || !destinationPortId) {
        showAlert('Please select both loading and destination ports', 'error');
        return;
      }

      const loadingPort = indianPorts.find(p => p.id === loadingPortId);
      const destinationPort = portsList.find(p => p.id === destinationPortId);
      
      if (!loadingPort || !destinationPort) {
        showAlert('Invalid port selection', 'error');
        return;
      }

      // Your exporter matching logic here
      showAlert(`Exporters for ${loadingPort.port} → ${destinationPort.port} would be shown here`, 'info');
      
    } catch (error) {
      console.error('Error:', error);
      showAlert('Failed to fetch exporter data', 'error');
    } finally {
      setLoadingExporters(false);
    }
  };

  // Upgrade Modal
  const UpgradeModal = ({ visible, onCancel, onUpgrade }) => {
    return (
      <Modal
        title="Upgrade Required"
        visible={visible}
        onCancel={onCancel}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            Maybe Later
          </Button>,
          <Button 
            key="upgrade" 
            type="primary" 
            onClick={onUpgrade}
          >
            View Subscription Plans
          </Button>,
        ]}
        centered
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ fontSize: 24 }}>🔒</div>
          <div>
            <p style={{ marginBottom: 4, fontWeight: 500 }}>This feature requires a higher plan</p>
            <p style={{ color: '#666' }}>
              Upgrade to Basic Plan or Premium Plan to view exporter company details.
            </p>
          </div>
        </div>
      </Modal>
    );
  };

  // On form submit
  // On form submit
// On form submit
// On form submit
// On form submit
const onFinish = async (values) => {
  setLoading(true);
  
  try {
    // Find port details
    const loadingPort = indianPorts.find(p => p.id === values.loadingPort);
    const destinationPort = portsList.find(p => p.id === values.destinationPort);
    
    if (!loadingPort || !destinationPort) {
      message.error('Please select valid loading and destination ports');
      setLoading(false);
      return;
    }

    // Format dates - ensure they're not null
    const priceValidity = values.pricevalidity ? 
      moment(values.pricevalidity).format('YYYY-MM-DD') : 
      null;
    
    const expectedDeparture = values.expectedDepartureDate ? 
      values.expectedDepartureDate.format('YYYY-MM-DD') : 
      null;

    if (!priceValidity || !expectedDeparture) {
      message.error('Please select both Price Validity and Expected Departure dates');
      setLoading(false);
      return;
    }

    // Prepare data - ensure NO null values for required fields
    const data = {
      loadingPort: `${loadingPort.port} (${loadingPort.code})`,
      destinationPort: `${destinationPort.port} (${destinationPort.code})`,
      oceanfreight: Number(values.oceanfreight) || 0,
      comments: values.comments || "",
      username: username || "",
      userid: parseInt(userid) || 0,
      currency: values.currency || "USD",
      pricevalidity: priceValidity,
      containerType: values.containerType || "",
      comapanyName: companyName || "",
      portPairs: [`${loadingPort.port} → ${destinationPort.port}`],
      expectedDepartureDate: expectedDeparture,
      transitDays: Number(values.transitDays),
      vesselName: values.vesselName ? values.vesselName.trim() : ""
    };

    // Debug: Log each field
    console.log('=== FIELD-BY-FIELD CHECK ===');
    const requiredFields = [
      { key: 'loadingPort', value: data.loadingPort },
      { key: 'destinationPort', value: data.destinationPort },
      { key: 'oceanfreight', value: data.oceanfreight, type: 'number' },
      { key: 'comments', value: data.comments },
      { key: 'username', value: data.username },
      { key: 'userid', value: data.userid, type: 'number' },
      { key: 'currency', value: data.currency },
      { key: 'pricevalidity', value: data.pricevalidity },
      { key: 'containerType', value: data.containerType },
      { key: 'comapanyName', value: data.comapanyName },
      { key: 'portPairs', value: data.portPairs, type: 'array' },
      { key: 'expectedDepartureDate', value: data.expectedDepartureDate },
      { key: 'transitDays', value: data.transitDays, type: 'number' }
    ];

    requiredFields.forEach(field => {
      const isEmpty = field.type === 'array' ? 
        !field.value || field.value.length === 0 :
        field.type === 'number' ? 
          (field.value === undefined || field.value === null || isNaN(field.value)) :
          !field.value || field.value.toString().trim() === '';
      
      console.log(`${field.key}: ${field.value} ${isEmpty ? '❌ EMPTY' : '✅ OK'}`);
    });

    // Validate all fields are present and not empty
    const validationErrors = requiredFields.filter(field => {
      if (field.type === 'array') {
        return !field.value || field.value.length === 0;
      }
      if (field.type === 'number') {
        return field.value === undefined || field.value === null || isNaN(field.value);
      }
      return !field.value || field.value.toString().trim() === '';
    });

    if (validationErrors.length > 0) {
      const errorFields = validationErrors.map(f => f.key).join(', ');
      message.error(`Please fill in: ${errorFields}`);
      setLoading(false);
      return;
    }

    console.log('=== ALL FIELDS VALID ===');
    console.log('Data to send:', data);

    // Make API call based on mode and selection
    if (isEditMode && editingRecordId) {
      // Edit mode - use update endpoint
      await handleFormUpdate(editingRecordId, data);
      message.success('Freight rate updated successfully!');
      setTimeout(() => history.push('/freight-market-rate-List'), 1000);
      
    } else {
      // Create mode - check if sending to specific exporter
      if (sendToType === 'specific' && selectedExporter) {
        // Use the specific exporters endpoint
        const apiEndpoint = `${BASE_API_CONFIG.baseURL}/updates-freight-rates/for-exporters`;
        
        // Add the target exporter and sendToAll flag to the data
        data.sendToAll = false;
        data.targetExporters = [selectedExporter.exporterId];
        
        console.log('=== SENDING TO SPECIFIC EXPORTER ===');
        console.log('Exporter ID:', selectedExporter.exporterId);
        console.log('Exporter Name:', selectedExporter.exporterCompany || selectedExporter.exporterName);
        console.log('Exporter Mobile:', selectedExporter.exporterMobile);
        console.log('Endpoint:', apiEndpoint);
        
        // Make the API call to specific endpoint
        const response = await axiosInstance({
          method: 'post',
          url: apiEndpoint,
          headers: { 'Content-Type': 'application/json' },
          data: data,
        });
        
        console.log('Response:', response.data);
        message.success(`Freight rate created and sent to ${selectedExporter.exporterCompany || selectedExporter.exporterName} successfully!`);
        
      } else {
        // Default to regular endpoint for "All Exporters"
        const apiEndpoint = `${BASE_API_CONFIG.baseURL}/updates-freight-rates`;
        
        console.log('=== SENDING TO ALL EXPORTERS ===');
        console.log('Endpoint:', apiEndpoint);
        
        // Make the API call to regular endpoint
        const response = await axiosInstance({
          method: 'post',
          url: apiEndpoint,
          headers: { 'Content-Type': 'application/json' },
          data: data,
        });
        
        console.log('Response:', response.data);
        message.success('Freight rate created successfully!');
      }
      
      // Navigate back after success
      setTimeout(() => history.push('/freight-market-rate-List'), 1000);
    }

  } catch (error) {
    console.error('=== FORM SUBMISSION ERROR ===');
    console.error('Error message:', error.message);
    console.error('Full error:', error);
    
    // Show specific error message
    if (error.message.includes('Missing required fields')) {
      message.error('Some required fields are missing. Please check all fields.');
    } else if (error.message.includes('API Error: 400')) {
      message.error('Invalid data. Please check your inputs.');
    } else if (error.message.includes('API Error: 500')) {
      message.error('Server error. Please try again later.');
    } else {
      message.error(error.message || 'An error occurred. Please try again.');
    }
  } finally {
    setLoading(false);
  }
};
  // Your existing API functions
  // Your API handler function
const handleFormSubmit = async (data) => {
  try {
    console.log('=== SENDING TO API ===');
    console.log('URL:', `${BASE_API_CONFIG.baseURL}/updates-freight-rates`);
    console.log('Request Data:', JSON.stringify(data, null, 2));
    
    const response = await axiosInstance({
      method: "post",
      url: `${BASE_API_CONFIG.baseURL}/updates-freight-rates`,
      headers: { "Content-Type": "application/json" },
      data: data,
    });
    
    console.log('=== API RESPONSE ===');
    console.log('Status:', response.status);
    console.log('Response Data:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('=== API ERROR ===');
    
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
      
      // Throw the actual error message from backend
      throw new Error(error.response.data?.message || `API Error: ${error.response.status}`);
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
      throw new Error('No response from server. Please check your network connection.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Request setup error:', error.message);
      throw error;
    }
  }
};

  // In Updatesfreightrates.js, update the handleFormUpdate function
const handleFormUpdate = async (id, data) => {
  try {
    console.log('Updating record:', id, data);
    
    const response = await axiosInstance({
      method: "PATCH",
      url: `${BASE_API_CONFIG.baseURL}/updates-freight-rates/${id}`,
      headers: { "Content-Type": "application/json" },
      data: data,
    });
    
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error updating freight rate:", error);
    
    if (error.response) {
      const status = error.response.status;
      let errorMessage = 'Failed to update freight rate';
      
      switch (status) {
        case 400: errorMessage = error.response.data?.message || 'Invalid request data'; break;
        case 401: errorMessage = 'Not authorized'; break;
        case 403: errorMessage = 'Can only edit your own rates'; break;
        case 404: errorMessage = 'Freight rate not found'; break;
        case 500: errorMessage = 'Server error'; break;
      }
      
      throw new Error(errorMessage);
    } else {
      throw error;
    }
  }
};

  return (
    <Card
      className="myexim-detail-card"
      title={
        <div className="myexim-table-title gx-text-capitalize">
          <LeftOutlined
            className={"back-icon"}
            onClick={() => history.goBack()}
            style={{ cursor: 'pointer' }}
          />
          {isEditMode ? "Edit" : "Create"} Freight Rate
        </div>
      }
    >
      <div style={{ position: 'relative' }}>
        {loading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
            borderRadius: '8px'
          }}>
            <div style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #1890ff",
              animation: "spin 1s linear infinite",
            }}></div>
          </div>
        )}
       
        <Form form={form} onFinish={onFinish} initialValues={{ currency: "USD" }}>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24}>
             <div style={{
  background: 'linear-gradient(135deg, #f5f7fa 0%, #f0f9ff 100%)',
  padding: '16px 20px',
  borderRadius: '10px',
  marginBottom: '24px',
  border: '1px solid #e6f7ff',
  boxShadow: '0 2px 8px rgba(25, 144, 255, 0.08)'
}}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '10px'
  }}>
    <BulbOutlined style={{ 
      color: '#1890ff', 
      fontSize: '18px',
      background: '#e6f7ff',
      padding: '6px',
      borderRadius: '50%'
    }} />
    <span style={{
      fontWeight: '600',
      color: '#0050b3',
      fontSize: '14px'
    }}>
      Note:
    </span>
  </div>
  <div style={{ 
    color: '#1d39c4',
    fontSize: '14px',
    lineHeight: '1.6',
    paddingLeft: '36px'
  }}>
    <div style={{ marginBottom: '8px' }}>
      ✓ Exporters will be able to view the Future date ETA vessel schedule along with the Freight Rates updated by you.
    </div>
    <div>
      ✓ Exporters will be able to view your company Name and contact details to place the booking directly with you.
    </div>
  </div>
</div>



  {!isEditMode  && (  //myExporters.length > 0 && 
              <Col xs={24} sm={24} md={24}>
                <Card size="small" style={{ marginBottom: 16, backgroundColor: '#fafafa', border: '1px solid #e8e8e8' }}>
           <div style={{ 
  marginBottom: 24,
  padding: 16,
  background: '#ffffff',
  borderRadius: 8,
  border: '1px solid #f0f0f0'
}}>
  <div style={{ marginBottom: 16 }}>
    <Space align="center" size={8}>
      <UserOutlined style={{ color: '#1890ff', fontSize: 16 }} />
      <span style={{ fontWeight: 500, fontSize: 14, color: '#1f1f1f' }}>Send this rate to:</span>
    </Space>
  </div>
  
  <Radio.Group 
    value={sendToType} 
    onChange={(e) => {
      setSendToType(e.target.value);
      if (e.target.value === 'all') {
        setSelectedExporter(null);
        setFilteredIndianPorts(indianPorts);
        setFilteredDestinationPorts(portsList);
      }
    }}
    buttonStyle="solid"
    size="middle"
    style={{
      display: 'flex',
      gap: '8px',
       width: '100%'
    }}
  >
    <Radio.Button 
      value="all"
      // style={{
      //   flex: 1,
      //   textAlign: 'center',
      //   borderRadius: '6px',
      //   height: '36px',
      //   lineHeight: '34px'
      // }}
    >
      All Exporters
    </Radio.Button>
    <Radio.Button 
      value="specific"
      // style={{
      //   flex:1,
      //   textAlign: 'center',
      //   borderRadius: '6px',
      //   height: '36px',
      //   lineHeight: '34px'
      // }}
    >
      My Exporter
    </Radio.Button>
  </Radio.Group>
</div>

                  {sendToType === 'specific' && (
                    <div>
                      <Select
                        showSearch
                        placeholder="Select an exporter"
                        style={{ width: '100%' }}
                        onChange={handleExporterChange}
                        value={selectedExporter?.exporterId}
                        loading={loadingMyExporters}
                        notFoundContent={loadingMyExporters ? <Spin size="small" /> : "No exporters found"}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {myExporters.map(exporter => (
                          <Option key={exporter.exporterId} value={exporter.exporterId}>
                            {exporter.exporterCompany || exporter.exporterName}
                          </Option>
                        ))}
                      </Select>
                      
                      {selectedExporter && (
                        <div style={{ marginTop: 12 }}>
                          <Alert
                            message={
                              <div>
                                <div><strong>Selected Exporter:</strong> {selectedExporter.exporterCompany || selectedExporter.exporterName}</div>
                                <div style={{ marginTop: 4 }}>
                                  <Tag color="blue">{exporterPortPairs.length} port pairs available</Tag>
                                  {loadingExporterPorts && <Spin size="small" style={{ marginLeft: 8 }} />}
                                </div>
                              </div>
                            }
                            type="info"
                            showIcon
                            icon={<UserOutlined />}
                          />
                          
                          {/* {exporterPortPairs.length > 0 && (
                            <div style={{ marginTop: 12, padding: '8px 12px', background: '#f5f5f5', borderRadius: 4 }}>
                              <div style={{ fontWeight: 500, marginBottom: 8 }}>Exporter's Port Pairs:</div>
                              {exporterPortPairs.map((pair, idx) => (
                                <Tag key={idx} color="processing" style={{ margin: '0 4px 4px 0' }}>
                                  {pair}
                                </Tag>
                              ))}
                            </div>
                          )} */}
                        </div>
                      )}
                    </div>
                  )}
                </Card>
              </Col>
              )}

            </Col>

            {/* Loading Port Dropdown - EXACTLY LIKE SIGNUP FORM */}
           {/* Loading Port Dropdown - Use filtered ports when exporter is selected */}
<Col xs={24} sm={12} md={12}>
  <Form.Item
    labelCol={{ span: 24 }}
    wrapperCol={{ span: 24 }}
    label={labelComponent("Loading Port", "(Indian Ports)")}
    name="loadingPort"
    rules={[
      {
        required: true,
        message: "Loading Port is required",
      },
    ]}
  >
    <Select
      showSearch
      size="large"
      placeholder="Select Indian Port"
      onChange={(value) => {
        setSelectedLoadingPort(value);
        handleLoadingPortChange(value); 
        form.setFieldsValue({ destinationPort: undefined });
      }}
      loading={!ports || ports.length === 0}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {/* Use filteredIndianPorts when exporter is selected, otherwise use all indianPorts */}
      {(selectedExporter ? filteredIndianPorts : indianPorts).map((port) => (
        <Select.Option key={port.id} value={port.id}>
          {`${port.port} (${port.code})`}
          {/* {selectedExporter && (
            <Tag color="blue" style={{ marginLeft: 8 }}>Matched</Tag>
          )} */}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
</Col>

{/* Destination Port Dropdown - Use filtered ports when exporter is selected */}
{/* Destination Port Dropdown */}
<Col xs={24} sm={12} md={12}>
  <Form.Item
    labelCol={{ span: 24 }}
    wrapperCol={{ span: 24 }}
    label={labelComponent("Destination Port", "(International Ports)")}
    name="destinationPort"
    rules={[
      {
        required: true,
        message: "Destination Port is required",
      },
      { validator: validatePortSelection },
    ]}
  >
    <Select
      showSearch
      size="large"
      placeholder={selectedLoadingPort ? "Select destination port" : "First select loading port"}
      onChange={(value) => setSelectedDestinationPort(value)}
      loading={!ports || ports.length === 0}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      getPopupContainer={(trigger) => trigger.parentNode}
      disabled={selectedExporter && !selectedLoadingPort}
      value={selectedDestinationPort}
    >
      {/* Determine which ports to show */}
      {(() => {
        let portsToShow = [];
        
        if (selectedExporter) {
          if (selectedLoadingPort) {
            // Show only destinations for selected loading port
            portsToShow = availableDestinationPorts;
            console.log('Showing available destinations:', availableDestinationPorts.length);
          } else {
            // Show all filtered destination ports
            portsToShow = filteredDestinationPorts;
            console.log('Showing filtered destinations:', filteredDestinationPorts.length);
          }
        } else {
          // Show all ports
          portsToShow = portsList;
          console.log('Showing all destinations:', portsList.length);
        }
        
        return portsToShow.map((port) => (
          <Select.Option key={port.id} value={port.id}>
            {`${port.port} (${port.code}) → ${port.countryName}`}
            {/* {selectedExporter && selectedLoadingPort && (
              <Tag color="green" style={{ marginLeft: 8 }}>Matched</Tag>
            )} */}
          </Select.Option>
        ));
      })()}
    </Select>
  </Form.Item>
  
  
              
              {/* View Matched Exporters Button */}
              {/* {form.getFieldValue("loadingPort") && form.getFieldValue("destinationPort") && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: isMobile ? '-38px' : '-35px',
                  marginRight: isMobile ? '0' : '10px'
                }}>
                  <Button 
                    type="link" 
                    onClick={() => {
                      if (!isSubscribed) {
                        setUpgradeModalVisible(true);
                        return;
                      }
                      showMatchedExporters();
                    }}
                    style={{ 
                      padding: isMobile ? '0 4px' : '0 8px',
                      fontSize: isMobile ? 13 : 14,
                      display: 'flex',
                      alignItems: 'center',
                      height: isMobile ? 32 : 'auto',
                      whiteSpace: 'nowrap'
                    }}
                    disabled={loadingExporters}
                  >
                    {loadingExporters ? (
                      <span>Loading...</span>
                    ) : (
                      <>
                        <EyeOutlined style={{ 
                          marginRight: isMobile ? 4 : 6,
                          fontSize: isMobile ? 14 : 16 
                        }} />
                        View Matched Exporters
                        {!isSubscribed && (
                          <Tag 
                            color="gold" 
                            style={{ 
                              marginLeft: isMobile ? 4 : 8,
                              fontSize: isMobile ? 11 : 11,
                              lineHeight: '14px',
                              padding: '0 2px'
                            }}
                          >
                            Upgrade
                          </Tag>
                        )}
                      </>
                    )}
                  </Button>
                </div>
              )} */}
            </Col>

            {/* OPTIONAL: Port Pairs Section (like signup form) - Uncomment if you want multiple port pairs */}
            {/*
            <Col span={24}>
              <div style={{ marginBottom: 20 }}>
                <Row gutter={16}>
                  <Col span={10}>
                    <Select
                      showSearch
                      size="large"
                      value={selectedLoadingPort}
                      onChange={setSelectedLoadingPort}
                      placeholder="Select Loading Port"
                      style={{ width: '100%' }}
                    >
                      {indianPorts.map((port) => (
                        <Select.Option key={port.id} value={port.id}>
                          {`${port.port} (${port.code})`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col span={10}>
                    <Select
                      showSearch
                      size="large"
                      value={selectedDestinationPort}
                      onChange={setSelectedDestinationPort}
                      placeholder="Select Destination Port"
                      style={{ width: '100%' }}
                    >
                      {portsList.map((port) => (
                        <Select.Option key={port.id} value={port.id}>
                          {`${port.port} (${port.code})`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  <Col span={4}>
                    <Button 
                      type="primary" 
                      onClick={addPortPair}
                      disabled={!selectedLoadingPort || !selectedDestinationPort}
                      block
                    >
                      Add Pair
                    </Button>
                  </Col>
                </Row>
                
                {portPairs.length > 0 && (
                  <div style={{ marginTop: 16 }}>
                    <h4>Selected Port Pairs ({portPairs.length}/5):</h4>
                    {portPairs.map((pair) => {
                      const loadingPort = indianPorts.find(p => p.id === pair.loadingPortId);
                      const destinationPort = portsList.find(p => p.id === pair.destinationPortId);
                      
                      return (
                        <div key={pair.id} style={{ marginBottom: 8 }}>
                          {loadingPort?.port} → {destinationPort?.port}
                          <Button type="link" danger onClick={() => removePortPair(pair.id)}>
                            Remove
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </Col>
            */}

            {/* Rest of your form fields (unchanged) */}
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Container Type"
                name="containerType"
                rules={[
                  {
                    required: true,
                    message: "Select Container type",
                  },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  placeholder="Select Container type"
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  <Option value={"20'drystandard"}>20' Dry Standard</Option>
                  <Option value={"40'Drystandard"}>40' Dry Standard</Option>
                  <Option value={"40'dryhighcube"}>40' Dry High Cube</Option>
                  <Option value={"45'dryhighcube"}>45' Dry High Cube</Option>
                  <Option value={"20'reefer"}>20' Reefer</Option>
                  <Option value={"40'reeferhighcube"}>40' Reefer High Cube</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent("Ocean Freight", "Offer Price")}
                required={true}
              >
                <Input.Group compact>
                  <div style={{display:"flex"}}>
                    <Form.Item
                      name="currency"
                      label="Currency"
                      noStyle
                      rules={[{ required: true, message: "Currency is required" }]}
                    >
                      <Select
                        showSearch
                        size="large"
                        placeholder="Select Currency"
                        defaultValue="ALL"
                        style={{ width:"40%" }}
                        disabled={isManufacturer(authUser)}
                      >
                        {countries
                          ?.filter((country, index) => {
                            if (isManufacturer(authUser)) {
                              return country.currencyCode === "USD";
                            } else {
                              return (
                                index ===
                                countries.findIndex((o) => country.currencyCode === o.currencyCode)
                              );
                            }
                          })
                          .map(
                            (option) =>
                              option.currencyCode && (
                                <Option key={option.id} value={option.currencyCode}>
                                  {option.currencyCode}
                                </Option>
                              )
                          )}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="oceanfreight"
                      noStyle
                      rules={[{ required: true, message: "Price is required" }]}
                    >
                      <Input
                        type="number"
                        defaultValue={0}
                        min={0}
                        placeholder="Enter Price"
                        size="large"
                        style={{ width:"60%" }}
                      />
                    </Form.Item>
                  </div>
                </Input.Group>
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={12}>
              <Form.Item
                label="Vessel Name"
                name="vesselName"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  placeholder="Enter Vessel name"
                  size="large"
                  showCount
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={12}>
              <Form.Item
                name="expectedDepartureDate"
                label="Vessel ETD"
                rules={[{ required: true, message: 'Please select departure date' }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <DatePicker 
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Select departure date"
                  disabledDate={(current) => current && current < moment().startOf('day')}
                />
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={12}>
              <Form.Item
                name="transitDays"
                label="Transit Days"
                rules={[{ required: true, message: 'Please enter transit days' }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <InputNumber
                  min={1}
                  max={365}
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Enter transit days"
                  addonAfter="days"
                />
              </Form.Item>
            </Col>

            <Col span={24} xs={24} sm={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Price Validity"
                name="pricevalidity"
                rules={[{
                  required: true,
                  message: "Price Validity Date is required",
                }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  getPopupContainer={(trigger) => trigger.parentNode}
                  disabledDate={(currentDate) => {
                    return currentDate && currentDate.isBefore(moment().startOf('day'));
                  }}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent("Comments/Addition Details")}
                name="comments"
                rules={[
                  {
                    validator: validateTextArea,
                  },
                  {
                    required: true,
                    message: "Comments are required",
                  },
                ]}
              >
                <TextArea
                  rows={10}
                  placeholder="Kindly Provide Local and destination charges."
                  showCount
                  maxLength={250}
                />
              </Form.Item>
            </Col>

            <Row className="gx-pt-5">
              <Col span={24}>
                <Form.Item className="gx-text-center">
                  <div
                    className="gx-mr-3"
                    style={{
                      justifyContent: "center",
                      justifyItems:"center",
                      alignItems:"center",
                      display: "flex",
                      flex: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      type="secondary"
                      size="large"
                      style={{ width: 150 }}
                      onClick={() => history.goBack()}
                    >
                      Cancel
                    </Button>

                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      style={{ width: 150 }}
                    >
                      Submit
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Row>
        </Form>
      </div>
      
      <UpgradeModal
        visible={upgradeModalVisible}
        onCancel={() => setUpgradeModalVisible(false)}
        onUpgrade={() => {
          setUpgradeModalVisible(false);
          history.push('/my-profile');
        }}
      />
    </Card>
  );
};

export default Updatesfreightrates;